import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';

import { CartSessionTokenService } from './cart-session-token.service';
import {
  CART_SESSION_REFRESH,
  CART_SESSION_START,
  CART_SESSION_USER_LOGOUT,
  RESERVE_CARD_ITEM,
  RELEASE_CARD_ITEM_RESERVE,
} from '../graphql/mutations/public-card.mutations';
import {
  GET_PUBLIC_CARD_BY_ID,
  LIST_PUBLIC_CARDS,
  PUBLIC_SELLER_CARD_ORDER_BY_ID,
} from '../graphql/queries/public-card.queries';

@Injectable({
  providedIn: 'root',
})
export class PublicCardService {
  constructor(
    private apollo: Apollo,
    private cartSessionTokenService: CartSessionTokenService,
  ) {}

  getCardById(cardId: string) {
    return this.apollo.query<any>({
      query: GET_PUBLIC_CARD_BY_ID,
      variables: {
        cardId,
      },
      fetchPolicy: 'no-cache',
    });
  }

  listCards(params: { page?: { page: number; size?: number }; search?: string; filters?: any }) {
    return this.apollo.query<any>({
      query: LIST_PUBLIC_CARDS,
      variables: {
        page: params.page,
        search: params.search,
        filters: params.filters,
      },
      fetchPolicy: 'no-cache',
    });
  }

  getPublicSellerCardOrderById(orderId: string) {
    return this.apollo.query<any>({
      query: PUBLIC_SELLER_CARD_ORDER_BY_ID,
      variables: { orderId },
      fetchPolicy: 'no-cache',
    });
  }

  startCartSession() {
    return this.apollo.mutate<any>({
      mutation: CART_SESSION_START,
      fetchPolicy: 'no-cache',
    });
  }

  refreshCartSession() {
    return this.apollo.mutate<any>({
      mutation: CART_SESSION_REFRESH,
      fetchPolicy: 'no-cache',
      context: this.buildCartSessionContext(),
    });
  }

  cartSessionUserLogout() {
    return this.apollo.mutate<any>({
      mutation: CART_SESSION_USER_LOGOUT,
      fetchPolicy: 'no-cache',
      context: this.buildCartSessionContext(),
    });
  }

  reserveCardItem(cardId: string, itemIndex: number) {
    const token = this.cartSessionTokenService.get();

    return this.apollo.mutate<any>({
      mutation: RESERVE_CARD_ITEM,
      variables: { cardId, itemIndex },
      fetchPolicy: 'no-cache',
      context: token
        ? {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        : undefined,
    });
  }

  releaseCardItemReserve(cardId: string, itemIndex: number) {
    const token = this.cartSessionTokenService.get();

    return this.apollo.mutate<any>({
      mutation: RELEASE_CARD_ITEM_RESERVE,
      variables: { cardId, itemIndex },
      fetchPolicy: 'no-cache',
      context: token
        ? {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        : undefined,
    });
  }

  private buildCartSessionContext() {
    const token = this.cartSessionTokenService.get();

    if (!token) {
      return undefined;
    }

    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }
}
